import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "../../../icons";
import cn from "../../../utils/cn";
import Button from "../../Button";
const PopoverIcon = ({ icon, className, ...props }) => {
    return icon ? (React.cloneElement(icon, {
        ...props,
        className: cn("!h-4 !w-4 text-gray !transition-all !duration-300 !ease-in-out  hover:text-gray-black data-[state=open]:text-gray-dark", className),
    })) : (_jsx(Button, { icon: _jsx(Icon, { name: "circle-help" }), variant: "ghost", size: "sm", color: "default", ...props }));
};
PopoverIcon.displayName = "Popover.Icon";
export default PopoverIcon;
